import gql from "graphql-tag";

export default gql`
  query IssuerDividends(
    $tickerSymbol: TickerSymbol!
    $securityCountry: SecurityCountry!
    $filterByExcludingFrom: Int
    $filterByExcludingTo: Int
  ) {
    issuerByTickerSymbol(tickerSymbol: $tickerSymbol, country: $securityCountry) {
      ... on BrazilianCompanyIssuer {
        mandatoryDividend {
          displayText
          periodicity
          periodicityDescription
          remarks
          hasPreferredSharesDividendAdvantage
        }
      }
    }

    dividendsPaid(
      tickerSymbol: $tickerSymbol
      country: $securityCountry
      filterByExcludingFrom: $filterByExcludingFrom
      filterByExcludingTo: $filterByExcludingTo
    ) {
      nodes {
        tickerSymbol
        recordDate
        excludingDate
        payDate
        amountPaid
        dividendType
        distributionFrequency
      }
      dividendsPaidByYear {
        tickerSymbol
        fiscalYear
        amountPaid
      }
      dividendYieldByTickerSymbol {
        tickerSymbol
        dividendYield
        amountPaid
      }
      availableYears
    }

    stockDividendsPaid(tickerSymbol: $tickerSymbol, country: $securityCountry) {
      tickerSymbol
      excludingDate
      sharePaid
    }
  }
`;
